export const formatPercent = (value: number, maximumFractionDigits?: number) => value
    .toLocaleString('ru', {
        style: 'percent',
        maximumFractionDigits,
    })
    .replace('\xa0%', '%')
